import { eventChannel } from 'redux-saga';

const keyboardEventChannel = () => {
  return eventChannel((emit) => {
    document.addEventListener('keyup', emit);
    document.addEventListener('keydown', emit);

    return () => {
      document.removeEventListener('keyup', emit);
      document.removeEventListener('keydown', emit);
    };
  });
};

export default keyboardEventChannel;
